/**
 *
 * Asynchronously loads the component for TemplatesPage
 *
 */

import loadable from '@loadable/component';

export default loadable(() => import('./index'));
